document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Cart drawer open/close ---------------- */
  var drawer = document.getElementById('cart-drawer');
  var toggleBtns = document.querySelectorAll('[data-cart-toggle]');
  var closeBtns = document.querySelectorAll('[data-cart-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    renderCartDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
  }
  toggleBtns.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('cart-drawer-items');
        var subtotalEl = document.getElementById('cart-drawer-subtotal');
        if (!itemsEl) return;

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p>Your cart is empty.</p>';
        } else {
          itemsEl.innerHTML = cart.items.map(function (item) {
            var planLabel = item.selling_plan_allocation
              ? '<span class="badge badge--save">' + item.selling_plan_allocation.selling_plan.name + '</span>'
              : '<span style="font-size:12px;color:#777;">One-time purchase</span>';
            return '' +
              '<div style="display:flex;gap:10px;margin-bottom:14px;">' +
              '<img src="' + (item.image || '') + '" width="60" height="60" style="border-radius:8px;object-fit:cover;">' +
              '<div style="flex:1;">' +
                '<div style="font-weight:600;font-size:14px;">' + item.product_title + '</div>' +
                planLabel +
                '<div style="font-size:13px;color:#555;margin-top:4px;">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
              '</div>';
          }).join('');
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- Product page ---------------- */
  var productSection = document.querySelector('.product-page');
  if (!productSection) return;

  var sectionId = productSection.getAttribute('data-section-id');
  var dataScript = document.getElementById('ProductJson-' + sectionId);
  var product = dataScript ? JSON.parse(dataScript.textContent) : null;

  var form = document.getElementById('ProductForm');
  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var priceWasEl = document.querySelector('.product-buybox__price-row .price-was');
  var subscribePriceEl = document.getElementById('SubscribePrice');
  var subscribeCompareEl = document.getElementById('SubscribeCompareAt');
  var onetimePriceEl = document.getElementById('OnetimePrice');
  var saveBadge = document.getElementById('SaveBadge');
  var frequencyDropdown = document.getElementById('FrequencyDropdown');
  var addToCartText = document.getElementById('AddToCartText');
  var subscribePanel = document.getElementById('SubscribePanel');
  var onetimeRow = document.querySelector('.onetime-row');

  var currentVariant = product ? findVariantById(variantIdInput.value) : null;

  function findVariantById(id) {
    if (!product) return null;
    id = parseInt(id, 10);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return product.variants[0];
  }

  function getAllocationForPlan(variant, planId) {
    if (!variant || !variant.selling_plan_allocations) return null;
    planId = parseInt(planId, 10);
    for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
      if (variant.selling_plan_allocations[i].selling_plan_id === planId) {
        return variant.selling_plan_allocations[i];
      }
    }
    return null;
  }

  /* ---------------- Size / variant option boxes ---------------- */
  document.querySelectorAll('.option-box-group').forEach(function (group) {
    var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
    group.querySelectorAll('.option-box').forEach(function (box) {
      box.addEventListener('click', function () {
        group.querySelectorAll('.option-box').forEach(function (b) { b.classList.remove('is-selected'); });
        box.classList.add('is-selected');

        var label = document.getElementById('SelectedOptionLabel-' + optionIndex);
        if (label) label.textContent = box.getAttribute('data-value');

        // Recompute selected variant from all option groups
        var selectedValues = [];
        document.querySelectorAll('.option-box-group').forEach(function (g) {
          var sel = g.querySelector('.option-box.is-selected');
          selectedValues.push(sel ? sel.getAttribute('data-value') : null);
        });
        if (product) {
          var match = product.variants.find(function (v) {
            return v.options.every(function (opt, idx) { return opt === selectedValues[idx]; });
          });
          if (match) {
            currentVariant = match;
            variantIdInput.value = match.id;
            updatePrices();
          }
        }
      });
    });
  });

  /* ---------------- Breed size guide (informational only) ---------------- */
  document.querySelectorAll('.breed-box').forEach(function (box) {
    box.addEventListener('click', function () {
      document.querySelectorAll('.breed-box').forEach(function (b) { b.classList.remove('is-selected'); });
      box.classList.add('is-selected');
    });
  });

  /* ---------------- Subscribe vs one-time ---------------- */
  function selectSubscribe() {
    if (subscribePanel) subscribePanel.classList.add('is-selected');
    if (onetimeRow) onetimeRow.classList.remove('is-selected');
    if (frequencyDropdown) frequencyDropdown.name = 'selling_plan';
    if (addToCartText) addToCartText.textContent = 'Add to Cart';
    updatePrices();
  }
  function selectOnetime() {
    if (subscribePanel) subscribePanel.classList.remove('is-selected');
    if (onetimeRow) onetimeRow.classList.add('is-selected');
    if (frequencyDropdown) frequencyDropdown.name = '';
    if (addToCartText) addToCartText.textContent = 'Add to Cart';
    updatePrices();
  }

  subscribePanel && subscribePanel.querySelector('.subscribe-panel__header').addEventListener('click', function (e) {
    if (e.target.tagName === 'SELECT') return;
    var radio = subscribePanel.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    selectSubscribe();
  });
  onetimeRow && onetimeRow.addEventListener('click', function () {
    var radio = onetimeRow.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    selectOnetime();
  });

  frequencyDropdown && frequencyDropdown.addEventListener('change', updatePrices);
  frequencyDropdown && frequencyDropdown.addEventListener('click', function (e) { e.stopPropagation(); });

  function updatePrices() {
    if (!currentVariant) return;

    if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(currentVariant.price);

    var allocation = null;
    if (frequencyDropdown) {
      allocation = getAllocationForPlan(currentVariant, frequencyDropdown.value);
    }

    if (allocation) {
      if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(allocation.price);
      if (subscribeCompareEl) {
        subscribeCompareEl.textContent = currentVariant.compare_at_price > allocation.price
          ? formatMoney(currentVariant.compare_at_price) : '';
      }
      if (saveBadge && currentVariant.compare_at_price > 0) {
        var pct = Math.round(((currentVariant.compare_at_price - allocation.price) / currentVariant.compare_at_price) * 100);
        if (pct > 0) saveBadge.textContent = 'SAVE ' + pct + '%';
      }
    }

    var isSubscribe = subscribePanel && subscribePanel.classList.contains('is-selected');
    var displayPrice = currentVariant.price;
    var displayCompare = currentVariant.compare_at_price;
    if (isSubscribe && allocation) {
      displayPrice = allocation.price;
    }
    if (priceEl) priceEl.textContent = formatMoney(displayPrice);
    if (priceWasEl) {
      priceWasEl.textContent = displayCompare > displayPrice ? formatMoney(displayCompare) : '';
      priceWasEl.style.display = displayCompare > displayPrice ? '' : 'none';
    }
  }

  /* Quantity stepper */
  var qtyInput = document.getElementById('Quantity');
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  });

  /* Gallery thumbs */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  /* Add to cart via AJAX -> open drawer */
  form && form.addEventListener('submit', function (e) {
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); });
  });

  /* Init */
  updatePrices();
});
